import React, { FC } from "react";
import { connect } from "react-redux";
import { PrimaryButton } from "office-ui-fabric-react";
import AzureAD, { IAzureADFunctionProps } from "react-aad-msal";
import { AuthProvider } from "../../AuthProvider";
import { store } from "../../.";
// import FullLogo from "./FullLogo";
import * as GeneralStore from "../../store/GeneralStore";
import { State } from "../../store";
import { mergeStyles } from "@fluentui/react";

type Props = GeneralStore.GeneralState;

const buttonIcon = mergeStyles({
  padding: "9px 10px",
  fontSize: 14,
  fontWeight: 700,
  // height: 40,
  // width: 40,
  justifyContent: "center",
  border: "1px solid var(--primary-500)",
  display: "flex",
  alignItems: "center",
  color: "var(--white-000)",
  background: "var(--primary-500)",
  borderRadius: 4,
  selectors: {
    [":active"]: {
      backgroundColor: "var(--primary-500)",
    },
  },
});

const LoginPage: FC<Props> = (props: Props) => {
  return (
    <AzureAD provider={AuthProvider} reduxStore={store.store}>
      {(a: IAzureADFunctionProps) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: "100vw",
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 15,
              alignItems: "center",
              padding: 24,
              borderBottom: "1px solid #D9D9D9",
            }}
          >
            <img src="/logo-white.svg" alt="" />
            <div
              style={{
                width: 1,
                height: 28,
                background: "#2D3030",
                opacity: 0.3,
              }}
            ></div>
            <span style={{ fontWeight: "bolder", fontSize: 24 }}>
              Statement of Facts
            </span>
          </div>
          <div
            style={{
              flexGrow: 1,
              background: "url(/bg-image.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "bottom",
              display: "grid",
            }}
          >
            <div
              style={{
                width: 448,
                height: 253,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 10,
                background: "#FFF",
                borderRadius: 8,
                placeSelf: "center",
                justifyContent: "center",
                boxShadow: "4px 4px 24px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <span
                style={{
                  fontWeight: "bolder",
                  fontSize: 24,
                }}
              >
                Welcome Back.
              </span>
              <span>Please select your QADworks Account</span>
              <div
                style={{
                  height: 30,
                }}
              ></div>
              <div>
                <PrimaryButton
                  className={buttonIcon}
                  text="QADworks Email Account"
                  iconProps={{ iconName: "WindowsLogo" }}
                  onClick={a.login}
                  styles={{
                    textContainer: {
                      flexGrow: "0",
                    },
                    root: {
                      width: "295px",
                      height: "48px",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </AzureAD>
  );
};

export default connect((state: State) => state.general)(LoginPage as any);
